import { ButtonProps, IconButton, } from '@chakra-ui/react';
import IconPencil from 'assets/icons/icon-pencil.svg?react';
import { Link, LinkProps } from 'react-router-dom';

type IconButtonEditProps = ButtonProps & LinkProps;

export default function IconButtonEdit(props: IconButtonEditProps) {
  return (
    <IconButton 
      aria-label="Editar"
      size="sm"
      icon={<IconPencil />}
      as={Link}
      {...props}
    />
  )
}
